"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import type { ReactNode } from "react";

type HeaderNavLinkProps = {
  href: string;
  children: ReactNode;
};

function normalizePath(value: string) {
  if (!value || value === "/") {
    return "/";
  }

  return value.endsWith("/") ? value.slice(0, -1) : value;
}

export function HeaderNavLink({ href, children }: HeaderNavLinkProps) {
  const pathname = normalizePath(usePathname() || "/");
  const target = normalizePath(href);
  const isActive = pathname === target || pathname.startsWith(`${target}/`);

  return (
    <Link aria-current={isActive ? "page" : undefined} className={isActive ? "is-active" : undefined} href={href}>
      {children}
    </Link>
  );
}
